
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/expertise/technology",
      function () {
        return require("private-next-pages/expertise/technology/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/expertise/technology"])
      });
    }
  